import { render, staticRenderFns } from "./PriceComparison.vue?vue&type=template&id=8503e944&scoped=true"
import script from "./PriceComparison.vue?vue&type=script&lang=js"
export * from "./PriceComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8503e944",
  null
  
)

export default component.exports